import { isTerminalState } from "constants/notificationJobStatus";
import React from "react";
import { POLL_INTERVAL_MS } from "../NotificationJobs";
import { MESSAGES, get } from "services/Client";

export default function useJobPollingManager({
    trackedJobs,
    activeJobPollersRef,
    timersByJobId,
    queryClient,
    scheduleAutoDelete
}) {
    React.useEffect(() => {
        for (const job of trackedJobs) {

            if (isTerminalState(job.status)) {
                stopJobPolling({ activeJobPollersRef, jobId: job.jobId });
                continue;
            }

            if (!isJobInPolling(activeJobPollersRef.current[job.jobId])) {
                startJobPolling({
                    job,
                    queryClient,
                    timersByJobId,
                    activeJobPollersRef,
                    scheduleAutoDelete
                })
            }
        }

     }, [activeJobPollersRef, scheduleAutoDelete, timersByJobId, queryClient, trackedJobs])
}

function startJobPolling({ job, queryClient, timersByJobId, activeJobPollersRef, scheduleAutoDelete }) {
    const id = job.jobId;

    const interval = setInterval(async () => {

        const { updJob } = await get(`${MESSAGES}/jobs/${id}`).then(response => ({ updJob: response.job }));

        if (!updJob) return;

        // aggiorna il job singolo in cache
        queryClient.setQueryData([MESSAGES, 'jobs', 'all'], oldJobs =>
            oldJobs?.map(
                j => j.jobId === id
                    ? updJob
                    : j
            )
        );

        if (timersByJobId.current[id]) {
            timersByJobId.current[id].nextPollAt = Date.now() + POLL_INTERVAL_MS;
        }

        //Aggiorno l'oggetto jobInPolling così che al prossimo refresh di getAllNotification mantengo questo poll
        activeJobPollersRef.current[id].job = updJob;

        // se diventa terminale → stoppa
        if (isTerminalState(updJob.status)) {
            stopJobPolling({ activeJobPollersRef, jobdId: id });
            scheduleAutoDelete(id);
        }
    }, POLL_INTERVAL_MS);


    timersByJobId.current[id] = {
        nextPollAt: Date.now() + POLL_INTERVAL_MS
    }

    activeJobPollersRef.current[id] = {
        job: job,
        interval: interval
    }
}

function stopJobPolling({activeJobPollersRef, jobId}) {
    let hasPollerStopped = false;
    const poller = activeJobPollersRef.current[jobId];
    if(poller) {
        clearInterval(poller.interval);
        delete activeJobPollersRef.current[jobId];
        hasPollerStopped = true;
    }
    return hasPollerStopped;
}

function isJobInPolling(poller) {
    return poller !== undefined;
}